/**
 * @generated SignedSource<<fc317bfe16e50e429ea2fdc62153e8fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldInput_text$data = {
  readonly translations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly locale: Locale;
        readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_textTranslation">;
      };
    }>;
  };
  readonly " $fragmentType": "TranslatableTextFieldInput_text";
};
export type TranslatableTextFieldInput_text$key = {
  readonly " $data"?: TranslatableTextFieldInput_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldInput_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldInput_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TextTranslationConnection",
      "kind": "LinkedField",
      "name": "translations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TextTranslationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextTranslation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locale",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TranslatableTextFieldTranslateButton_textTranslation"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "2332d60269f39df28bc624f631af35dd";

export default node;
